<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.21673023841858,8.88178e-16C9.21673023841858,1.36752,9.584670238418578,2.46154,10.32056023841858,3.28205C12.77350023841858,5.19658,14.000000238418579,7.38462,14.000000238418579,9.84615C14.000000238418579,12.5812,12.528200238418579,14.6325,9.584670238418578,16C11.750000238418579,13.6,11.42439023841858,12.6154,9.21673023841858,9.6C6.875000238418579,10.8,7.250000238418579,11.6,7.625000238418579,13.2C6.839320238418579,13.2,6.125000238418579,13.2,5.750000238418579,12.8C5.750000238418579,13.347,6.647540238418579,14.8,7.214320238418579,16C4.27077023841858,15.1795,1.1219542384185792,10.2564,2.225787238418579,9.84615C2.961675238418579,9.57265,3.8202102384185794,9.7094,4.801400238418579,10.2564C3.574920238418579,5.33333,5.046690238418579,1.91453,9.21673023841858,8.88178e-16C9.21673023841858,8.88178e-16,9.21673023841858,8.88178e-16,9.21673023841858,8.88178e-16Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Flame',
} as DefineComponent
</script>
